function SeoTalkToExpert(props){
    return(
        <div>
            <span>We only audited the 200 pages from your website. However, to audit all the pages from your website with personalized recommendations, talk to our experts today!</span>           
            <span><a className="expert-button" href={props.redirectInfo.cta_button_link} >Talk To Our Expert</a></span>
        </div>
    )
}

export default SeoTalkToExpert